export default "__VITE_ASSET__a2042521__"